import { extendTheme } from "@chakra-ui/react";
import { CardComponent } from "./additions/card/card";
import { buttonStyles } from "./components/button";
import { badgeStyles } from "./components/badge";
import { inputStyles } from "./components/input";
import { progressStyles } from "./components/progress";
import { sliderStyles } from "./components/slider";
import { textareaStyles } from "./components/textarea";
import { switchStyles } from "./components/switch";
import { linkStyles } from "./components/link";
import { breakpoints } from "./foundations/breakpoints";
import { globalStyles } from "./styles";


const layerStyles = {
  tableRowStyle: {
    fontSize: { base: "12px", md: "14px", lg: "16px" }, // responsive font sizes
    lineHeight: { base: "18px", md: "21px", lg: "24px" }, // responsive line height
    fontWeight: "400",
    backgroundColor: "teal",
  },
};

// Export theme (same structure, no layout change)
export default extendTheme(
  {
    breakpoints,
    layerStyles, // fixed key name and added responsive values
  },
  globalStyles,
  badgeStyles, // badge styles
  buttonStyles, // button styles
  linkStyles, // link styles
  progressStyles, // progress styles
  sliderStyles, // slider styles
  inputStyles, // input styles
  textareaStyles, // textarea styles
  switchStyles, // switch styles
  CardComponent // card component
);
